<div class="modal-header">
    <h4 class="modal-title">Are you sure?</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <p>
        If you would like to archive <strong>{{ petName }}</strong>, please confirm so <strong>{{ petName }}</strong> won't be shown here anymore.
    </p>
    <p>
        You can undo this later, if you decide to.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger text-white" ngbAutofocus (click)="activeModal.dismiss()">
      Cancel
    </button>
    <button type="button" class="btn btn-success text-white" (click)="activeModal.close()">
      Confirm
    </button>
  </div>